
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Cookies from 'js-cookie'
import { getNickName, removeToken } from '@/utils/auth'
import { resolveMediaUrl, alternateMediaUrl } from '@/utils/mediaUrl'
import {
isEnlargeMode,
setEnlargeMode,
isEyeCareMode,
setEyeCareMode
} from '@/utils/displayPrefs'

const DEFAULT_AVATAR = require('@/assets/6_1_touxiang.png')

export default {
directives: { TransferDom },
components: { Confirm },
data () {
return {
confirmShow: false,
dialogVisible: false,
popupContent: '欢迎使用添加微信功能，长按图片保存二维码可添加商家微信',
wechatNumber: 'danciyinhang',
checkinStatus: {},
badgeCount: 0,
pointsCount: 0,
reviewCount: {},
book: {},
userAvatar: '',
enlargeMode: isEnlargeMode(),
eyeCareMode: isEyeCareMode()
}
},
computed: {
nickName () {
return getNickName() || '用户'
},
avatarUrl () {
const path = (this.userAvatar || '').trim()
if (!path) return DEFAULT_AVATAR
return resolveMediaUrl(path)
},
studyMenus () {
return [
{ key: 'mybooks', label: '我的词书', icon: 'bookmark-o', color: '#4a90e2', bg: '#eef5ff', action: this.goMyBooks },
{ key: 'practice', label: '练习中心', icon: 'records', color: '#fa8c16', bg: '#fff7e6', action: this.goPractice },
{ key: 'search', label: '单词搜索', icon: 'search', color: '#00b894', bg: '#e8faf5', action: this.goSearch }
]
},
reviewMenus () {
return [
{ key: 'review', label: '智能复习', icon: 'replay', color: '#4a90e2', bg: '#eef5ff', badge: this.reviewCount.total_count || '', action: this.goReviewPractice },
{ key: 'error', label: '错题本', emoji: '📕', bg: '#fff1f0', badge: this.reviewCount.error_book_count || '', action: this.goErrorBook },
{ key: 'star', label: '重点词', emoji: '⭐', bg: '#fffbe6', badge: this.reviewCount.star_count || '', action: this.goStarReview }
]
},
growthMenus () {
return [
{ key: 'stats', label: '学习数据', icon: 'chart-trending-o', color: '#4a90e2', bg: '#eef5ff', action: this.goStats },
{ key: 'report', label: '学习报告', icon: 'description', color: '#6c5ce7', bg: '#f3f0ff', action: this.goWeeklyReport },
{ key: 'rank', label: '打卡排行', icon: 'medal-o', color: '#52c41a', bg: '#f6ffed', action: this.goRanking }
]
},
innovMenus () {
return [
{ key: 'mp', label: '记忆宫殿', emoji: '🏛', bg: '#e8eef5', action: () => this.$router.push({ path: '/mpHome_display', query: { from: 'mine' } }) },
{ key: 'cp', label: '语境拼图', emoji: '🧩', bg: '#fff7e6', action: () => this.$router.push({ path: '/cpHome_display', query: { from: 'mine' } }) },
{ key: 'et', label: '词源树', emoji: '🌳', bg: '#f6ffed', action: () => this.$router.push({ path: '/etHome_display', query: { from: 'mine' } }) },
{ key: 'sl', label: '故事擂台', emoji: '📖', bg: '#f3f0ff', action: () => this.$router.push({ path: '/slHome_display', query: { from: 'mine' } }) },
{ key: 'card', label: '生存卡', emoji: '🎴', bg: '#fff1f0', action: () => this.$router.push('/cpCollection_display') }
]
}
},
created () {
this.loadBook()
this.loadUserProfile()
},
activated () {
this.enlargeMode = isEnlargeMode()
this.eyeCareMode = isEyeCareMode()
this.loadBook()
this.loadUserProfile()
},
methods: {
loadUserProfile () {
this.$ajax.get(this.$api.userProfile).then(user => {
if (!user) return

const avatar = (user.avatar || (user.user && user.user.avatar) || '').trim()
this.userAvatar = avatar
}).catch(() => {})
},
onAvatarError (e) {
const el = e && e.target
if (!el) return
const alt = alternateMediaUrl(el.src)
if (alt && el.dataset.avatarFallback !== '1') {
el.dataset.avatarFallback = '1'
el.src = alt
return
}
el.onerror = null
el.src = DEFAULT_AVATAR
},
loadSummary () {
this.$ajax.get(this.$api.checkinStatus).then(res => { this.checkinStatus = res || {} }).catch(() => {})
this.$ajax.get(this.$api.achievementList).then(res => {
if (res) this.badgeCount = res.unlocked_count || 0
}).catch(() => {})
this.$ajax.get(this.$api.pointsAccount).then(res => {
if (res) this.pointsCount = res.available_points || 0
}).catch(() => {})
let reviewUrl = this.$api.reviewTodayCount
if (this.book.categoryId) reviewUrl += '?category_id=' + this.book.categoryId
this.$ajax.get(reviewUrl).then(res => { this.reviewCount = res || {} }).catch(() => {})
},
loadBook () {
this.$ajax.post(this.$api.getUserInfo, { key: 'studyBookID' }).then(r => {
this.book = r || {}
this.loadSummary()
})
},
goMyBooks () { this.$router.push('/myBooks') },
goSearch () { this.$router.push({ path: '/wordSearch_display', query: { hideTrans: 'true' } }) },
goPractice () { this.$router.push({ path: '/practice?hideTrans=true' }) },
goReviewPractice () {
this.$router.push({
path: '/reviewHome_display',
query: { categoryId: this.book.categoryId, from: 'mine' }
})
},
goErrorBook () {
this.$router.push({ path: '/reviewErrorBook_display', query: { from: 'mine' } })
},
goStarReview () {
this.$router.push({
path: '/reviewPractice_display',
query: { review_type: 'star', categoryId: this.book.categoryId, from: 'mine' }
})
},
goStats () { this.$router.push('/statsHome_display') },
goStatsCalendar () { this.$router.push('/statsCalendar_display') },
goCheckin () { this.$router.push('/checkinCalendar_display') },
goWeeklyReport () { this.$router.push('/statsWeekly_display') },
goRanking () { this.$router.push('/checkinRanking_display') },
goAchievement () { this.$router.push('/achievementList_display') },
goPoints () { this.$router.push('/pointsLog_display') },
goActivation () { this.$router.push({ path: '/activation', query: { from: 'mine' } }) },
addWx () { this.dialogVisible = true },
dialogConfirm () {
this.copyToClipboard(this.wechatNumber)
this.$vux.toast.text('微信号已复制到剪贴板', 2000)
this.dialogVisible = false
},
dialogClose () {},
copyToClipboard (text) {
if (navigator.clipboard && window.isSecureContext) {
return navigator.clipboard.writeText(text)
}
const textarea = document.createElement('textarea')
textarea.value = text
textarea.setAttribute('readonly', '')
textarea.style.position = 'absolute'
textarea.style.left = '-9999px'
document.body.appendChild(textarea)
textarea.select()
try { document.execCommand('copy') } catch (e) { /* ignore */ }
document.body.removeChild(textarea)
},
goTocjwt () { this.$router.push('/cjwt') },
test () { this.$router.push('/gywm') },
goProfileEdit () { this.$router.push('/profileEdit') },
updatePassword () { this.$router.push('/updatePassword') },
onEnlargeChange (enabled) {
setEnlargeMode(enabled)
this.$vux.toast.text(enabled ? '已开启字体放大' : '已关闭字体放大', 1500)
},
onEyeCareChange (enabled) {
setEyeCareMode(enabled)
this.$vux.toast.text(enabled ? '已开启护眼模式' : '已关闭护眼模式', 1500)
},
logoff () { this.confirmShow = true },
onConfirm () {
removeToken()
Cookies.remove('NickName')
this.$router.push('/sysLogin_display')
}
}
}



// WEBPACK FOOTER //
// ./src/views/publicView/Mine.vue